import { useContext } from 'react';
import { SidebarContext, SidebarContextProps } from '../../Components/Sidebar/Sidebar.tsx';

export function useSidebar(): SidebarContextProps {
  return useContext(SidebarContext)!;
}
